// src/components/CustomFields/fields/HyperLinkField.tsx
// HyperLinkField component migrated from legacy

import React from 'react';
import CustomFieldsService from '../../../api/CustomFieldsService';
import $ from 'jquery';
import ClickOutSide from '../../Globals/ClickOutSide';
import './HyperLinkField.css';
import type { BaseFieldProps, CustomFieldItem } from './types';

interface HyperLinkFieldState {
  value: string;
  EditorEnabled: boolean;
  editableValue: string;
  disableAutoSave: boolean;
  customField: CustomFieldItem;
  canEdit: boolean;
  apiConfig: { url: string; token: string };
}

class HyperLinkField extends React.Component<BaseFieldProps, HyperLinkFieldState>
{
  private fieldARef = React.createRef<HTMLDivElement>();

  constructor(props: BaseFieldProps)
  {
    super(props);
    this.state = {
      value:
        props.customField.Value === null || props.customField.Value === undefined
          ? ''
          : String(props.customField.Value),
      EditorEnabled: props.EditorEnabled || false,
      editableValue: '',
      disableAutoSave: props.disableAutoSave || false,
      customField: props.customField,
      canEdit: props.canEdit && props.customField.ConversationIsEnable !== false,
      apiConfig: props.apiConfig,
    };

    this.handleChange = this.handleChange.bind(this);
    this.save = this.save.bind(this);
    this.enableEditor = this.enableEditor.bind(this);
    this.disableEditor = this.disableEditor.bind(this);
    this.onUpdateCustomField = this.onUpdateCustomField.bind(this);
  }

  componentWillReceiveProps(nextProps: BaseFieldProps)
  {
    if (
      nextProps.customField.Value !== this.state.customField.Value ||
      nextProps.customField.CustomFieldValueId !== this.state.customField.CustomFieldValueId
    )
    {
      this.setState({
        customField: nextProps.customField,
        value: nextProps.customField.Value === null ? '' : String(nextProps.customField.Value),
      });
    }
  }

  handleChange(event: React.ChangeEvent<HTMLInputElement>)
  {
    this.setState({ value: event.target.value });
  }

  save()
  {
    const { disableAutoSave, editableValue, value } = this.state;

    const copyCustomField = { ...this.state.customField };

    if (value !== editableValue && value != null)
    {
      copyCustomField.Value = value;
      copyCustomField.PreviousValue = editableValue;
      this.setState({ editableValue: value });
      this.disableEditor();

      if (value !== '')
      {
        if (
          value.substring(0, 7) !== 'http://' &&
          value.substring(0, 8) !== 'https://' &&
          value.substring(0, 6) !== 'ftp://'
        )
        {
          copyCustomField.Value = 'http://' + value;
          this.setState({
            value: copyCustomField.Value as string,
            editableValue: copyCustomField.Value as string,
          });
        }
      }

      // Do not save if autoSaved is disabled
      if (!disableAutoSave)
      {
        const requestSave = {
          api: this.props.apiConfig,
          request: copyCustomField,
        };

        if (
          copyCustomField.CustomFieldValueId === undefined ||
          copyCustomField.CustomFieldValueId === null ||
          copyCustomField.CustomFieldValueId === 0
        )
        {
          CustomFieldsService.savePost(requestSave).then((data: any) =>
          {
            copyCustomField.CustomFieldValueId = data.CustomFieldValueId;

            try
            {
              this.setState({ customField: copyCustomField }, () =>
              {
                this.onUpdateCustomField();
              });
            }
            catch (err)
            {
              // Handle error
            }
          });
        }
        else
        {
          CustomFieldsService.save(requestSave).then(() =>
          {
            try
            {
              this.setState({ customField: copyCustomField }, () =>
              {
                this.onUpdateCustomField();
              });
            }
            catch (err)
            {
              // Handle error
            }
          });
        }
      }
      else
      {
        // Disable the control
        this.disableEditor();

        this.setState({ customField: copyCustomField }, () =>
        {
          this.onUpdateCustomField();
        });
      }
    }
    else
    {
      // Disable the control
      this.disableEditor();
    }
  }

  enableEditor()
  {
    const { canEdit, value } = this.state;

    if (canEdit)
    {
      const element = $(this.fieldARef.current!);
      const a = element.offset()!.left + 100;
      const layerContainer = element.closest('.layer-details-container');
      const b =
        layerContainer.length > 0
          ? layerContainer.offset()!.left + layerContainer.outerWidth()!
          : window.innerWidth;

      if (a > b)
      {
        element.find('input').css({
          width: '50px',
        });
      }

      this.setState({ EditorEnabled: true, editableValue: value });
    }
  }

  disableEditor()
  {
    this.setState({ EditorEnabled: false });
  }

  onUpdateCustomField()
  {
    if (this.props.UpdateCustomFields)
    {
      this.props.UpdateCustomFields(this.state.customField);
    }
  }

  render()
  {
    const { EditorEnabled, canEdit, value, customField } = this.state;

    return (
      <div
        key={'cf-' + customField.CustomFieldId}
        ref={this.fieldARef}
        className="corgee_com_custom-fields-field-A _DEL_field-A custom-field-id"
      >
        {customField.GroupMultiEditionType === 1 && (
          <i
            className="material-icons several-values enable-help-tooltip"
            title="Not all cards selected have this detail. The detail value will change only on applicable cards."
            data-title="Not all cards selected have this detail. The detail value will change only on applicable cards."
          >
            do_not_disturb_on
          </i>
        )}
        <span className="corgee_com_custom-fields-title _DEL_title">{customField.Name}</span>
        {!customField.GroupMultiEditionType && (
          <i
            className="material-icons not-filterable enable-help-tooltip"
            data-title="This detail type is not filterable"
          >
            do_not_disturb_on
          </i>
        )}

        <div className="click-to-edit">
          <div className="lbl-editable-hyperlink">
            {!EditorEnabled && value !== undefined && value !== '' ? (
              <div>
                <a
                  href={value}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lbl-editable-link"
                >
                  {value}
                </a>

                {canEdit ? (
                  <a onClick={this.enableEditor} className="enable-editor-button">
                    <span className="icon-pencil-icon"></span>
                  </a>
                ) : null}
              </div>
            ) : null}
            {!EditorEnabled && (value === undefined || value === '') ? (
              <div
                onClick={this.enableEditor}
                className={canEdit ? 'lbl-editable-input' : 'lbl-non-editable-input'}
              >
                Not set
              </div>
            ) : null}
          </div>

          {EditorEnabled ? (
            <ClickOutSide onClickOutSide={this.save}>
              <div id="layerField" className="corgee_com_custom-fields-input-hyperlink">
                <div className="ctrl-editable-input" style={{ left: 0, right: 'initial' }}>
                  <input
                    value={value}
                    onChange={this.handleChange}
                    onBlur={this.save}
                    aria-invalid="false"
                    autoFocus
                  />
                </div>
              </div>
            </ClickOutSide>
          ) : null}
        </div>
      </div>
    );
  }
}

export default HyperLinkField;
